import { COMPANY_TIER, NO_LEVEL } from 'utils/Config';

interface TierConfigDict {
  noExclusiveCampaign: boolean;
  noLevel: boolean;
  noTicket: boolean;
}

const StarterTierConfig: TierConfigDict = {
  noExclusiveCampaign: true,
  noLevel: true,
  noTicket: true,
};

const GrowthTierConfig: TierConfigDict = {
  noExclusiveCampaign: true,
  noLevel: true,
  noTicket: true,
};

const ProTierConfig: TierConfigDict = {
  noExclusiveCampaign: false,
  noLevel: false,
  noTicket: false,
};

class ServerConfig {

  static getTierConfigDict(): TierConfigDict {
    // companyTier: Starter, Growth or Pro
    const tier = COMPANY_TIER ?? 'pro';
    switch (`${tier}`.toLowerCase()) {
      case 'starter':
        return StarterTierConfig;
      case 'growth':
        return GrowthTierConfig;
      case 'pro':
      default:
        return ProTierConfig;
    }
  }

  static getNoLevel(): boolean {
    // return false;
    return this.getTierConfigDict().noLevel || NO_LEVEL;
  }

  static getNoTicket(): boolean {
    return this.getTierConfigDict().noTicket;
  }

  static getNoOnlyForYouCampaign(): boolean {
    return this.getTierConfigDict().noExclusiveCampaign;
  }
}

export default ServerConfig;
